import { createStore, combineReducers, applyMiddleware } from "redux";
import { todosReducer } from "../shared/lib/store/todosReducer";
import { timeAllTodosReducer } from "../shared/lib/store/timeAllTodosReducer";
import { dataTodoIncomingReducer } from "../shared/lib/store/incomingTodosReducer";
import { dataTodoRemovedReducer } from "../shared/lib/store/removedTodosReducer";
import { dataTagReducer } from "../shared/lib/store/tagsReducer";
// import { userParamsReducer } from "../store/userParamsReducer";
import { settingsReducer } from "../shared/lib/store/settingsReducer";
import { todosCompletedReducer } from "../shared/lib/store/completedTodosReducer";
import { checkListReducer } from "../shared/lib/store/chekListReducer";
import { taskCounterReducer } from "../shared/lib/store/StatisticsStore/TaskCounterReducer";
import { workTimeReducer } from "../shared/lib/store/WorkTimeStore/WorkTimeReducer";
import { percentCounterReducer } from "../shared/lib/store/StatisticsStore/TaskPercentCounterReducer";
import { tagsToTaskReducer } from "../shared/lib/store/TagsToTasksStore/TagsToTasksReducer";
import { stopWatchesDataReducer } from "../shared/lib/store/RunTimeTaskResults/RunTimeResults";
import { spentTimeReducer } from "../shared/lib/store/SpentTimeTask/SpentTimeReducer";
import thunk, { ThunkDispatch } from "redux-thunk";
import type { AnyAction } from "redux";
import notificationReduser from "../shared/lib/store/notificationReduser";
import { calendarTodosReducer } from "../shared/lib/store/calendarTodosReducer";
import { completedTodosOnRangeReducer } from "../shared/lib/store/StatisticsStore/CompletedTodosOnRangeReducer";
import { topForecastReducer } from "../shared/lib/store/StatisticsStore/TopForecastReducer";
import { topTagsReducer } from "../shared/lib/store/StatisticsStore/TopTagsReducer";
import { elapsedTimeToTodosReducer } from "../shared/lib/store/StatisticsStore/ElapsedTimeToTodosReducer";
import { onContextReduser } from "../shared/lib/store/contextMenuTaskReducer";
import taskTabelReducer from "../Pages/settings-page/widgets/TaskStats/TaskTableSection/store/TaskTableSectionStore";
import { repeatTemplateReducer } from "../shared/lib/store/repeatTemplateReducer";
import { authReducer } from "../features/auth/reducer";
import getTagsReducer from "../features/select-tags/model/getTagsReducer";
import getUserDataReducer from "../features/user/getUserDataReducer";
import { sortSlice } from "../features/filter/model/sort.slice";
import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from "react-redux";
import { templateTaskSlice } from "../shared/lib/store/template-task-slice/template-task-slice";
import { notesSlice } from "../widgets/notes/model/slice/notes-slice";
import { contextNotesSlice } from "../widgets/notes/model/slice/notes-contextmenu-slice";
import { focusedTaskSlice } from "../features/focus-task/model/focus-task.slice";
import { matrixSlice } from "../features/matrix-task/model/matrix-task.slice";
import { submenuSlice } from "../shared/layouts/submenu/model/submenu-model.slice";
import { subscriptionSlice } from "../entities/subscription";
import { taskUpdatesReducer } from "../shared/lib/store/taskUpdatesReducer";

import { taskMotionReducer } from "../shared/lib/store/taskMotionReducer";

const rootReducer = combineReducers({
    taskMotion: taskMotionReducer,
    taskUpdates: taskUpdatesReducer,
    tags: dataTagReducer,
    tagsNew: getTagsReducer,
    todos: todosReducer,
    time: timeAllTodosReducer,
    todosIncoming: dataTodoIncomingReducer,
    todosRemoved: dataTodoRemovedReducer,
    // userParams: userParamsReducer,
    settings: settingsReducer,
    todosCompleted: todosCompletedReducer,
    checkList: checkListReducer,
    countTask: taskCounterReducer,
    workTime: workTimeReducer,
    countPercentTask: percentCounterReducer,
    tagsArray: tagsToTaskReducer,
    notification: notificationReduser,
    stopWatchesData: stopWatchesDataReducer,
    spentTime: spentTimeReducer,
    todosCalendar: calendarTodosReducer,
    completedTodosOnRange: completedTodosOnRangeReducer,
    topForecast: topForecastReducer,
    topTags: topTagsReducer,
    elapsedTimeToTodos: elapsedTimeToTodosReducer,
    onContextState: onContextReduser,
    taskTableState: taskTabelReducer,
    templatesState: repeatTemplateReducer,
    authUser: authReducer,
    userAuthSettings: getUserDataReducer, //New state of response user settings for auth
    [sortSlice.name]: sortSlice.reducer,
    [templateTaskSlice.name]: templateTaskSlice.reducer,
    [notesSlice.name]: notesSlice.reducer,
    [contextNotesSlice.name]: contextNotesSlice.reducer,
    [focusedTaskSlice.name]: focusedTaskSlice.reducer,
    [matrixSlice.name]: matrixSlice.reducer,
    [submenuSlice.name]: submenuSlice.reducer,
    [subscriptionSlice.name]: subscriptionSlice.reducer
})

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppStore = useStore;
export const store = createStore(rootReducer, applyMiddleware(thunk));
